import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpParamsOptions } from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
    }),
  };

  constructor(public http: HttpClient) { }

  getNotificationList(startDate?: any, endDate?: any) {
    let url = this.BASE_URL + "notificationInbox/list";
    if (startDate && endDate) {
      url += "?startDate=" + startDate + "&endDate=" + endDate;
    }
    return this.http.get(url, this.OPTIONS);
  }

  getUnreadNotifications() {
    const url = this.BASE_URL + "notificationInbox/list/unread";
    return this.http.get(url, this.OPTIONS);
  }

  getUnreadCount() {
    const url = this.BASE_URL + "notificationInbox/count/unread";
    return this.http.get(url, this.OPTIONS);
  }

  markNotificationRead(uuid: string) {
    const url = this.BASE_URL + "notificationInbox/markRead?uuid=" + uuid;
    return this.http.patch(url, this.OPTIONS);
  }

}

